import { AUCTION_TYPES } from 'constants';
import { useSelector } from 'react-redux';
import {
  required,
  sellerValidateCounter,
  validateCounter,
  validateMinBid,
  validateMinOffer,
  validateReservePrice
} from 'utils/validators';

export const useReservePriceValidation = (auctionType: string, inBattle = false) => {
  if (auctionType === AUCTION_TYPES.SECOND_CHANCE) {
    return [required, validateReservePrice];
  }

  return [validateReservePrice];
};

export const useCounterValidator = (auctionType: string) => {
  const user = useSelector((state: any) => state.user.user);
  console.log(user, 'user counter');
  const counterValidation = user?.role === 'seller' ? sellerValidateCounter : validateCounter;
  if (auctionType === AUCTION_TYPES.AUTOAXESS) {
    return [];
  }
  if (auctionType === AUCTION_TYPES.SECOND_CHANCE) {
    return [required, counterValidation];
  }

  return [counterValidation];
};

export const useStartingBidValidator = (auctionType: string) => {
  console.log(auctionType, 'useStartingBidValidator');
  if (auctionType !== AUCTION_TYPES.AUTOAXESS) {
    return [required, validateMinOffer];
  }

  return [validateMinBid];
};
